"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageType = void 0;
exports.PageType = {
    READ: '조회',
    CREATE: '등록',
    UPDATE: '수정',
};
